import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.004 9.835c-1.128 1.07-2.486 3.115-4.097 6.586a1 1 0 1 1-1.814-.842c1.639-3.53 3.125-5.859 4.536-7.196.713-.676 1.452-1.141 2.227-1.347a3.4 3.4 0 0 1 2.258.17c1.326.572 2.378 1.913 3.252 3.353.893 1.47 1.724 3.26 2.526 4.987l.015.033c.819 1.764 1.607 3.459 2.436 4.824.852 1.403 1.629 2.25 2.334 2.553.314.136.618.165.953.076.355-.095.81-.34 1.366-.867 1.128-1.07 2.486-3.116 4.097-6.586a1 1 0 0 1 1.814.842c-1.639 3.53-3.125 5.858-4.535 7.195-.714.677-1.453 1.142-2.228 1.348a3.4 3.4 0 0 1-2.258-.17c-1.326-.572-2.378-1.913-3.252-3.353-.893-1.47-1.724-3.261-2.526-4.987l-.015-.033c-.819-1.764-1.607-3.46-2.436-4.824-.852-1.403-1.629-2.25-2.334-2.554a1.4 1.4 0 0 0-.953-.075c-.355.095-.81.34-1.366.867"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconWaveSine = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconWaveSine);
export default Memo;
